import { useIntl } from "react-intl";
// import { MenuItem } from "./MenuItem";
// import { MenuInnerWithSub } from "./MenuInnerWithSub";
// import { MegaMenu } from "./MegaMenu";

export function MenuInner() {
	//const intl = useIntl();
	return (
		<>
			{/* <MenuItem title={intl.formatMessage({id: 'MENU.DASHBOARD'})} to='/clients' /> */}
			{/* <MenuItem title='Home' to='/home' /> */}
			{/* <MenuInnerWithSub isMega={true} title='Client Management' to='/mega-menu' menuPlacement='bottom-start' menuTrigger='click'>
				<MegaMenu />
			</MenuInnerWithSub> */}
			{/* <MenuItem title="Game Category" to='/game-category' />
      <MenuItem title="Reports" to='/reports' />
      <MenuItem title="Players" to='/players' />
      <MenuItem title="Games" to='/games' /> */}
			{/* <MenuItem title='Search Client / User' to='/search-user' /> */}
		</>
	);
}
